var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view", attrs: { id: "contract-tree-grid" } },
    [
      _c(
        "div",
        {
          staticStyle: { display: "flex", "flex-direction": "row", flex: "1" }
        },
        [
          _c("ul", { staticClass: "custom-category-list section" }, [
            _c(
              "li",
              {
                class: [_vm.contractStatusCode === -1 ? "active" : ""],
                on: {
                  click: function($event) {
                    return _vm.categoryClick(-1)
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("CargoMsg.Cargo_All")) +
                    "(" +
                    _vm._s(_vm.allCount) +
                    ")"
                )
              ]
            ),
            _c(
              "li",
              {
                staticClass: "expired",
                class: [
                  _vm.contractStatusCode ===
                  _vm.ContractConstants.STAGE_EXPIRED.code
                    ? "active"
                    : ""
                ],
                on: {
                  click: function($event) {
                    return _vm.categoryClick(
                      _vm.ContractConstants.STAGE_EXPIRED.code
                    )
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("CargoMsg.Cargo_Expired")) +
                    "(" +
                    _vm._s(_vm.expiredCount) +
                    ")"
                )
              ]
            ),
            _c(
              "li",
              {
                staticClass: "willExpired",
                class: [
                  _vm.contractStatusCode ===
                  _vm.ContractConstants.STAGE_WILLEXPIRED.code
                    ? "active"
                    : ""
                ],
                on: {
                  click: function($event) {
                    return _vm.categoryClick(
                      _vm.ContractConstants.STAGE_WILLEXPIRED.code
                    )
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("CargoMsg.Cargo_NearExpiration")) +
                    "(" +
                    _vm._s(_vm.willExpiredCount) +
                    ")"
                )
              ]
            ),
            _c(
              "li",
              {
                staticClass: "unExpired",
                class: [
                  _vm.contractStatusCode ===
                  _vm.ContractConstants.STAGE_UNEXPIRED_AND_POSTPONED.code
                    ? "active"
                    : ""
                ],
                on: {
                  click: function($event) {
                    return _vm.categoryClick(
                      _vm.ContractConstants.STAGE_UNEXPIRED_AND_POSTPONED.code
                    )
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("CargoMsg.Cargo_NotVetDueEytended")) +
                    "(" +
                    _vm._s(_vm.unExpiredCount) +
                    ")"
                )
              ]
            ),
            _c(
              "li",
              {
                staticClass: "history",
                class: [
                  _vm.contractStatusCode ===
                  _vm.ContractConstants.STAGE_HISTORY.code
                    ? "active"
                    : ""
                ],
                on: {
                  click: function($event) {
                    return _vm.categoryClick(
                      _vm.ContractConstants.STAGE_HISTORY.code
                    )
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("CargoMsg.Cargo_History")) +
                    "(" +
                    _vm._s(_vm.historyCount) +
                    ")"
                )
              ]
            )
          ]),
          _c(
            "div",
            { staticClass: "main-content" },
            [
              _c(
                "search-item",
                {
                  attrs: {
                    "config-module": "101500",
                    reset: true,
                    "custom-sim-query-placeholder": _vm.$t(
                      "CargoMsg.Cargo_QuickSearchContractNumber"
                    ),
                    "custom-search-items": _vm.customSearchItems,
                    "record-expand-status": true
                  },
                  on: {
                    "click-more": function(value) {
                      return (this$1.isAdvancedQuery = value)
                    },
                    simSearchItemCallBack: _vm.toSimpleQuery,
                    advSearchItemCallBack: _vm.toAdvancedQuery
                  }
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "operations" }, slot: "operations" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.$checkPermission([
                                "button_ContractManagement_addContract"
                              ]),
                              expression:
                                "$checkPermission(['button_ContractManagement_addContract'])"
                            }
                          ],
                          attrs: { no: "add", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.createHandler()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.$checkPermission([
                                "button_ContractManagement_contractConfig"
                              ]),
                              expression:
                                "$checkPermission(['button_ContractManagement_contractConfig'])"
                            }
                          ],
                          attrs: {
                            no: "contractConfiguration",
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.configHandler()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("CargoMsg.Cargo_ContractConfiguration")
                            )
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "logRecord", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.showLogHandler()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_LogRecord")))]
                      ),
                      _c("workflow", {
                        staticStyle: {
                          display: "inline",
                          "margin-left": "5px"
                        },
                        attrs: {
                          "document-config-name": "SYS_CONTRACT",
                          job: _vm.selectedItem,
                          "state-key": "state"
                        },
                        on: { success: _vm.handleWorkflowSuccess }
                      }),
                      _c(
                        "label",
                        {
                          staticStyle: {
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: "#CC6666",
                            "padding-left": "10px"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("CargoMsg.Cargo_Reminder30Day")) +
                              " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "section grid-wrapper",
                  staticStyle: { "min-height": "350px" }
                },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      "config-module": "101501",
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData,
                      "wrap-text": true,
                      "grid-params": _vm.gridParams
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      },
                      gridReady: _vm.onGridReady
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "pagination-wrapper" },
                [
                  _c("cargo-pagination", {
                    attrs: {
                      "config-module": "101501",
                      total: _vm.total,
                      page: _vm.filter.pageNum,
                      limit: _vm.filter.pageSize
                    },
                    on: {
                      "update:page": function($event) {
                        return _vm.$set(_vm.filter, "pageNum", $event)
                      },
                      "update:limit": function($event) {
                        return _vm.$set(_vm.filter, "pageSize", $event)
                      },
                      pagination: function($event) {
                        return _vm.toAdvancedQuery()
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm.contractConfigWindow.visible
        ? _c("contract-config-window", {
            attrs: {
              visible: _vm.contractConfigWindow.visible,
              model: _vm.contractConfigWindow.contractConfig
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.contractConfigWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.contractEditWindow.visible
        ? _c("contract-edit-window", {
            attrs: {
              visible: _vm.contractEditWindow.visible,
              type: _vm.contractEditWindow.type,
              model: _vm.contractEditWindow.contract
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.contractEditWindow, "visible", $event)
              },
              reload: _vm.reload
            }
          })
        : _vm._e(),
      _vm.contractLogWindow.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                "custom-class": "",
                "close-on-click-modal": false,
                visible: _vm.contractLogWindow.visible,
                title: _vm.$t("CargoMsg.Cargo_LogRecord")
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.contractLogWindow, "visible", $event)
                },
                close: function($event) {
                  _vm.contractLogWindow.visible = false
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "app-main-inner-row row-grid" },
                [
                  _c("cargo-ag-grid", {
                    style: { width: "100%", height: "450px" },
                    attrs: {
                      "grid-options": _vm.contractLogWindow.gridOptions,
                      "column-defs": _vm.contractLogWindow.columnDefs,
                      "row-data": _vm.contractLogWindow.rowData
                    }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _c("contract-upload-file", {
        attrs: {
          visible: _vm.uploadCommonFile.visible,
          model: _vm.uploadCommonFile.model,
          title: _vm.$t("Message.fileManagement"),
          "config-module": "101502",
          lob: "PT",
          "document-category": _vm.uploadCommonFile.documentCategory
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.uploadCommonFile, "visible", $event)
          },
          onUploadDone: _vm.onUploadDone
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }